import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { UserHelper } from '../../../helpers/user.helper';
import { UserService } from '../../../apis/services/user.service';
import { AuthService } from '../../../apis/services/auth.service';
import { UserDetail } from '../../../apis/models/userDetail';
import { ResetPasswordRequest } from '../../../apis/models/resetPasswordRequeste';
import { UserTypeEnum } from '../../../apis/enums/userType.enum';
import { CommonHelpers } from '../../../helpers/common.helper';


@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrl: './user-details.component.scss'
})
export class UserDetailsComponent implements OnInit {
    user: UserDetail = {
        username: '',
        email: '',
        accountType: UserTypeEnum.NULL
    }
    protected readonly userTypes = Object.keys(UserTypeEnum).filter(key => isNaN(Number(key)));

    constructor(
        private route: ActivatedRoute,
        private userService: UserService,
        private authService: AuthService,
        private userHelper: UserHelper,
        private commonHelpers: CommonHelpers,
        private router: Router) 
    {}

    ngOnInit(): void {
        const userId = this.route.snapshot.paramMap.get('id');
        if (userId) {
            this.userService.getUserById(Number(userId)).subscribe(user => {
                if (user) {
                    this.user = user;
                    console.log(this.user)
                } else {
                    this.commonHelpers.openSnackBar("Nessun utente trovato!", 'x', 4);
                    this.router.navigate(['/']);
                }
            })
        }
    }

    getEnumDescription(type: string): string {
        return UserTypeEnum[type as keyof typeof UserTypeEnum];
    }

    onSubmitForm(userForm: NgForm) {
        if (userForm.valid) {
            this.userService.updateUser(this.user).subscribe((response: any) => {
                if (response && response && response.status == 'success') {
                    this.router.navigate(['/users']);
                } else {
                    this.commonHelpers.openSnackBar("Si è verificato un errore creando l'utente", 'x', 4);
                }
            })
        }
    }

    saveAndResetPsw(userform: NgForm) {
        if (userform.valid) {
            let sendPswRequest: ResetPasswordRequest = {username: this.user.username ?? '', email: this.user.email ?? '', newUser: true}
            this.userService.updateUser(this.user).subscribe((response: any) => {
                if (response && response && response.status == 'success') {
                    this.authService.resetPassword(sendPswRequest).subscribe((response: any) => {
                        if (response) {
                            this.commonHelpers.openSnackBar("Email inviata con successo", 'x', 4);
                        } else {
                            this.commonHelpers.openSnackBar("Si è verificato un errore con l'invio della mail.", 'x', 4);
                        }
                    })
                    this.router.navigate(['/users']);
                } else {
                    this.commonHelpers.openSnackBar("Si è verificato un errore creando l'utente", 'x', 4);
                }
            })
        }
    }
}
